import { KitComposicao } from './kit-composicao';

export class Kit {
  id: number;
  idPainel: number;
  painel: string;
  idInversor: number;
  inversor: string;
  potencia: number;
  tensao: number;
  fase: number;
  tipoTelhado: number;
  tipoTelhadoDescricao: string;
  valorAplicado: number;
  valorProduto: number;
  valorAtualizado: number;
  da: number;
  idProduto: number;
  idFornecedor: number;
  fornecedor: string;
  idFornecedorEstrutura: number;
  fornecedorEstrutura: string;
  orientacao: number;
  estruturaDescricao: string;
  composicao: KitComposicao[];
  checado: boolean;
  potenciaReal: number;
  descricao: string;
  editando: boolean;
  valorCusto: number;
  obs: string;
  salvo: boolean;
  possuiOrcPed: boolean;
  ativo: boolean;
  dtDisponibilidade: Date;
  menuOrigem: number;
}
